import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  fontFamily: "Open Sans",
  fontSemiBold: "600",
  fontSemiBold700: "700",
});
export default theme;
